var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item",style:({
    left: _vm.x + 'px',
    top: _vm.y + 'px',
    width: _vm.width + 'px',
    height: _vm.height + 'px',
    zIndex: _vm.zIndex
  }),on:{"click":_vm.modify}},[_c('div',{staticClass:"wrap"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]),_c('span',{staticClass:"dev"},[_vm._v(_vm._s(_vm.info))])])])}
var staticRenderFns = []

export { render, staticRenderFns }